var getComment = function getComment(node) {
  return node.nodeName === '#comment' && node.nodeValue && node.nodeValue.indexOf('mr_counter') >= 0 && node.nodeValue.indexOf('/mr_counter') === -1;
};

var filterNone = function filterNone(node) {
  // обрабатываем только комментарии
  // от обычных пикселей отказались
  return getComment(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
};

export var nodeSetToArray = function nodeSetToArray(nodeSet) {
  return Array.prototype.slice.call(nodeSet);
};
export var getNodes = function getNodes(root) {
  var elements = []; // Fourth argument, which is actually obsolete according to the DOM4 standard, is required in IE 11

  var iterator = document.createNodeIterator(root, NodeFilter.SHOW_COMMENT, filterNone, // @ts-ignore
  false);
  var curNode; // tslint:disable-next-line: no-conditional-assignment

  while (curNode = iterator.nextNode()) {
    if (curNode && curNode.nodeValue) {
      elements.push(curNode.nodeValue);
    }
  }

  return elements;
};